export class QueryLogin {
    user!: string
    password!: string
    company?: boolean
}